import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Header({ showSearchPanel, onToggleSearch, hideSearch }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [fontSize, setFontSize] = useState(
    localStorage.getItem("fontSize") || "16px"
  );

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty("--base-font-size", fontSize);
    localStorage.setItem("fontSize", fontSize);
  }, [fontSize]);

  return (
    <header className={`app-header ${isScrolled ? "scrolled" : ""}`}>
      <h1 className="app-title">Fond du Lac County News</h1>

      {/* Constrained header content */}
      <div className="header-inner">
        <div className="app-meta">
          <span className="secondary-title">
            A Recipes for Freedom Publication
          </span>
          <span className="date">
            {new Date().toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        </div>

        <hr className="hr-divider" />

        <div className="header-controls">
          <div className="font-size-controls">
            <button onClick={() => setFontSize(`${parseInt(fontSize) + 2}px`)}>
              Font +
            </button>
            <button onClick={() => setFontSize(`${parseInt(fontSize) - 2}px`)}>
              Font -
            </button>
          </div>
          <button onClick={() => navigate("/submit")}>
            Submit an Article
          </button>
          {!hideSearch && (
            <button
              className="search-toggle"
              onClick={onToggleSearch}
              aria-label={showSearchPanel ? "Close search" : "Open search"}
            >
              {showSearchPanel ? (
              <>
                <span className="search-icon">✕</span>
                <span className="search-text">Close Search</span>
              </>
              ) : (
              <>
                <span className="search-icon">🔍</span>
                <span className="search-text">Search</span>
              </>
              )}
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
